// getIsRemoteConfigMerged.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Select is remote config merged by priority
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {number} priority - remote config priority.
 * @return {boolean} return true if current priority remote config merged.
 */
const getIsRemoteConfigMerged = createCachedSelector(
  (state, priority) =>
    !!getOperationData(state, ['config', 'remoteConfigMerged', `${priority}`]),
  (state, priority) =>
    !!getOperationData(state, ['config', 'abTestConfigMerged', `${priority}`]),
  (isRemoteConfigMerged, isABTestConfigMerged) =>
    isRemoteConfigMerged && isABTestConfigMerged
)((state, priority) => `${priority}`);

export default getIsRemoteConfigMerged;
